import reducer from './ipm-reducer';

export default reducer;
export { initialState } from './ipm-reducer';

export * from './ipm-actions';
